
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regional-meetup",
      function () {
        return require("private-next-pages/regional-meetup/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regional-meetup"])
      });
    }
  